import { useEffect } from 'react';
import { poserTitreDocument } from '../marque/marque';

/**
 * Titre de l'onglet de l'écran affiché (RGAA 8.6, TF-341) : « Connexion · TOP
 * FORMATION ». Les écrans de l'espace connecté le reçoivent de la coque
 * (`TitreEcran`) ; les pages publiques le posent elles-mêmes.
 */
export function useTitrePage(titre: string | null): void {
  useEffect(() => {
    poserTitreDocument({ ecran: titre });
    return () => poserTitreDocument({ ecran: null });
  }, [titre]);
}
